import React from "react";
import { Row, Col } from "reactstrap";
import { useFormContext } from "react-hook-form";
import { useWizard } from "react-use-wizard";
import withStyles from "isomorphic-style-loader/withStyles";
import * as yup from "yup";
import WizardFormStep from "../../components/WizardFormStep";
import s from "../../brandSetup/editGivingSite/components/styles.scss";
import pageLayoutImage from "../../../../../../media/img/page-layout.png";
import { Card, CardContent, CardMedia } from "@mui/material";
import PrimaryButton from "../../../../../../toolkit/primaryButton";

export const phoneNumberMethodSelectionSchema = yup.object({
  phoneNumberMethod: yup.string().required("Please select a phone number method"),
});

const PhoneNumberMethodSelection: React.FC = () => {
  const { setValue } = useFormContext();
  const { nextStep } = useWizard();

  const handleNewNumberClick = () => {
    setValue("phoneNumberMethod", "newNumber");
    nextStep();
  };

  const handlePortNumberClick = () => {
    setValue("useSharedTcr", false);
    setValue("sharedTcrEntryId", "");
    setValue("phoneNumberMethod", "portNumber");
    nextStep();
  };

  return (
    <WizardFormStep
      title="Choose Your Phone Number Method"
      subtitle="Select how you want to get your MMS phone number"
    >
      <Row className="justify-content-center mt-4 mb-3">
        <Col md="auto" className="mb-3">
          <Card
            onClick={handleNewNumberClick}
            sx={{
              width: 250,
              height: 300,
              display: "flex",
              flexDirection: "column",
              borderRadius: "10px",
              border: "1px solid #E2E8F0",
              cursor: "pointer",
              transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              },
            }}
          >
            <CardMedia
              component="img"
              width="100%"
              height="120"
              image={pageLayoutImage}
              alt="Get New Number"
              sx={{
                objectFit: "contain",
                padding: "12px 16px 0 16px",
              }}
            />
            <CardContent sx={{ textAlign: "center" }}>
              <h3 className={s.cardTitle}>Get New Number</h3>
              <p className={s.cardDescription}>
                We'll purchase a new phone number in your area
              </p>
              <div style={{ marginTop: "10px" }}>
                <PrimaryButton variant="secondary" className={s.startButton}>
                  Select
                </PrimaryButton>
              </div>
            </CardContent>
          </Card>
        </Col>

        <Col md="auto" className="mb-3">
          <Card
            onClick={handlePortNumberClick}
            sx={{
              width: 250,
              height: 300,
              display: "flex",
              flexDirection: "column",
              borderRadius: "10px",
              border: "1px solid #E2E8F0",
              cursor: "pointer",
              transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              },
            }}
          >
            <CardMedia
              component="img"
              width="100%"
              height="120"
              image={pageLayoutImage}
              alt="Port My Number"
              sx={{
                objectFit: "contain",
                padding: "12px 16px 0 16px",
              }}
            />
            <CardContent sx={{ textAlign: "center" }}>
              <h3 className={s.cardTitle}>Port My Number</h3>
              <p className={s.cardDescription}>
                Transfer your existing number to our service
              </p>
              <div style={{ marginTop: "10px" }}>
                <PrimaryButton variant="secondary" className={s.startButton}>
                  Select
                </PrimaryButton>
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </WizardFormStep>
  );
};

export default withStyles(s)(PhoneNumberMethodSelection);
